import classNames from 'classnames';

import styles from '../../styles/partials/blocked.module.css';

interface BlockedProps {
    unblocked?: boolean;
    short?: boolean;
    className?: string | null;
}

function Blocked({ unblocked = false, short = false, className = null }: BlockedProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.unblocked]: unblocked,
                },
                className,
            ])}
        >
            <span className={classNames(['material-symbols-rounded', styles.icon])}>
                {unblocked ? 'lock_open_right' : 'lock'}
            </span>
            <span className={styles.label}>
                {short
                    ? unblocked
                        ? 'Abonnés'
                        : 'Abonnés'
                    : unblocked
                      ? 'Exclusif aux abonnés'
                      : 'Exclusif aux abonnés'}
            </span>
        </div>
    );
}

export default Blocked;
